'use client';

import { useOverlayTriggerState } from '@react-stately/overlays';
import { useAuth } from 'react-oidc-context';

import { AvatarScratch, Logout } from '@zoomit/icons';
import { Avatar, cssVar, TextIcon, theme, Typography } from '@zoomit/zoomit-ds';

import { BaseMediaUrl } from '../../constants/apis';
import LogoutModal from './LogoutModal';
import ProfileLinksMobile from './ProfileLinksMobile';

type Props = {
  signOutLoading: boolean;
  handleSignOut(): void;
};

const MenuProfileMobile = (props: Props) => {
  const { signOutLoading, handleSignOut } = props;

  const logoutModal = useOverlayTriggerState({});

  const { user } = useAuth();

  return (
    <>
      <div className="px-4">
        <div className="mt-4 flex items-center justify-between">
          <div className="flex items-center gap-2">
            {user?.profile.picture ? (
              <Avatar size="medLarge" src={`${BaseMediaUrl}/${user.profile.picture}`} />
            ) : (
              <AvatarScratch size="lx" fill={cssVar(theme.grey1)} />
            )}
            <Typography fontSize={1.4} fontWeight={700}>
              {user?.profile.name}
            </Typography>
          </div>
          <div className="items-center gap-4">
            <TextIcon
              className={'cursor-pointer'}
              rightIcon={<Logout size="sm" />}
              onClick={logoutModal.open}
            >
              <Typography fontSize={1.2} fontWeight={400}>
                خروج
              </Typography>
            </TextIcon>
          </div>
        </div>
        <ProfileLinksMobile className="mt-4" />
      </div>

      {logoutModal.isOpen && (
        <LogoutModal onClose={logoutModal.close} isLoading={signOutLoading} mutate={handleSignOut} />
      )}
    </>
  );
};

export default MenuProfileMobile;
